module.exports = __webpack_public_path__ + "img/2020.010282a5.svg";